
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import {
    ScannedBarcode, ScannedBarcodeState,
    UpdateBarcodeListCommandArgumentsState, ChangePorterByBarcodeCommandArguments,
    ChangePorterByBarcodeCommandResponse, ChangePorterByBarcodeViewModel,
    ScannedBarcodeDetailsViewModel, PorterListViewModel,
    IPorterViewModel,
    GenericFieldDescription,
    DownloadBarcodeListRequestArguments,
    ChangePorterByBarcodeCommandArgumentsState
} from 'Api/CoreApi';

import { BarcodeTableEntry } from './BarcodeTableComponent';
import ABarcodeActionsComponent from './ABarcodeActionsComponent';
import ApiProvider from 'Api/ApiProvider';
import 'select2';
import Axios from 'axios';
import barcodestore from 'Store/barcode/barcodestore';

@Component({
    template: '#barcode-change-porter-template'
})
export class BarcodeChangePorterComponent extends ABarcodeActionsComponent {
    list: ChangePorterByBarcodeViewModel[] = null;

    porterList: PorterListViewModel = null;

    selectedPorter: IPorterViewModel = {};

    //_barcodes: ScannedBarcode[] = null;
    // _changeBarcodeImageUrl : string = '';

    // async created() {

    //     //this._barcodes = new Array<ScannedBarcode>();


    //     // console.log(this.barcodes,"di.barcodes");
    //     // this._barcodes.push(<ScannedBarcode>{
    //     //     state : ScannedBarcodeState.CUSCHP,
    //     // });



    //     this.setLoading();
    //     this.setLoaded();
    //     await this.getPorterList();

    //     try{

    //     } catch(error){}

    //     // this.$nextTick(() => {

    //     //     // var selectTarget = <any>this.$refs.porterselector;

    //     // })
    //     //TODO: mso - works as shit!
    //     $('.porters-select').select2();

    //     this.tableEvents = {
    //         add: null,
    //         remove: null,
    //         update: this.updateBarcode
    //     };

    //     this.availableStates = Object.keys(ScannedBarcodeState)
    //     .filter(value => value == ScannedBarcodeState.CUSCHP);



    // }
    // get canExport2(){

    //     return this.list.filter(x=>!x.details.isValid).length > 0 && this.list.length > 1;
    // }


    // get canValidate2(){

    //     return !this.list.some(x => !this.barcodeIsValid(x));
    // }

    // checkStuff(){



    // }

    // // get entries(){
    // //  try{
    // //     console.log(this.barcodes,"dis barcodeds");

    // //     let data = this.barcodes.map((x: ScannedBarcode, index: number) =>
    // //     <BarcodeTableEntry>{
    // //         index: index,
    // //         showDetails: false,
    // //         value: x
    // //     });
    // //     console.log(data, "dis data");


    // //     return data;
    // //  }catch(e){
    // //  console.log("err",e);
    // // }
    // // return null;
    // // }

    // get barcodes(){
    //     return this.list ? this.list : [];
    // }



    get viewModelFields(): GenericFieldDescription[] {
        return this.porterList ? this.porterList.fields : [];

    }

    // getBarcodeDetails(index: number): ScannedBarcodeDetailsViewModel{
    //     if(!this.list) return;

    //     return this.list[index].details;
    // }

    get canValidat1(){
        
        return this.selectedPorter && this.selectedPorter.id && !this.barcodes.some(x => !this.barcodeIsValid(x));
    }


    // // trigger update on changed values from the v-model
    // //-else the store state is not mutated to current values
    // async updateBarcode(event: any, index: number, value: ScannedBarcode){
    //     //if any changes - we cannot guarantee the valid state
    //     this._isValidated = false;


    //     this.list[index] = value;
    //     this.list = this.list.slice();
    //     console.log("updating barcode",this.barcodes,this.list);
    //     this.$forceUpdate();

    // }

    async getPorterList() {

        const client = ApiProvider.getApiClient();
        const result = await client.getPorterList();


        this.porterList = result;

    }
    // async validateScannedBarcodes(){ 

    //     this.triggerValidateOnTable = false;
    //     this.waiting = true;
    //     this.errorValidate = false;
    //     this._isValidated = false;


    //         this.triggerValidateOnTable = true;                    
    //     try{


    //         const result = await this.validate(this.selectedState);
    //         this._isValidated = result.isValid;
    //         this.errorValidate = !result.isValid;
    //         console.log(result);

    //     }catch(error){
    //         this.errorValidate = true;
    //         console.log(error);
    //         console.log(this.list);

    //     }

    //     this.waiting = false;
    // }

    // async validate(status:string): Promise<ChangePorterByBarcodeCommandResponse>{
    //    this.test = false;


    //     //-----------------
    //     console.log(status,"validating  <---");
    //     if(!this.barcodes || !this.selectedPorter) return;

    //     const scannedBarcodePorterMap: { [key: string]: string; }= {};

    //     this.barcodes.forEach((value: ScannedBarcode, index: number) => {
    //         scannedBarcodePorterMap[this.selectedPorter.id] = value.number;
    //     });
    //     console.log(status,"validating2  <---");

    //     const client = ApiProvider.getApiClient();
    //     const result = await client.changePorterByBarcode(<ChangePorterByBarcodeCommandArguments><unknown>{
    //         state: status as UpdateBarcodeListCommandArgumentsState,
    //         Barcode: this.barcodes[0],
    //         ToPorter: this.selectedPorter.id,
    //     });

    //     console.log(result,"result <---");

    //    this.errorValidate = !result.isValid;


    //     //this.test = true; 
    //     barcodestore.updateList(result.list.map(x => x.item));

    //     this.list = result.list;
    //     console.log("list now contains:",this.list);
    //     this.test = true;
    //     //map validated barcodes to store !
    //     //add validation list to component

    //     return result;
    // }

    // async exportValidatedBarcodes(){
    //     if(!this.list) return;
    //     //map model to export obj

    //     const client = ApiProvider.getApiClient();
    //     const result = await client.downloadScannedBarcodes(<DownloadBarcodeListRequestArguments>{
    //         list: this.list
    //     });

    //     console.debug('export response: ', result);
    //     console.debug('export content: ', atob(result.content));

    //     await this.export(this.selectedState,result.json);
    // }


    async created() {


        this.availableStates = Object.keys(ScannedBarcodeState)
        .map(key => key)
        .filter(value => value == ScannedBarcodeState.CUSCHP);


        this.setLoading();

        await this.getPorterList();

        try {

        } catch (error) { }

        this.$nextTick(() => {

            var selectTarget = <any>this.$refs.porterselector;

        })
        //TODO: mso - works as shit!
        $('.porters-select').select2();
        // if(!this.barcodes || this.barcodes.length == 0)
        //     this.addBarcode(null);

        this.setLoaded();
    }


    getBarcodeDetails(index: number): ScannedBarcodeDetailsViewModel {
        if (!this.list) return;
        if (!this.list[index] || !this.list[index].details) return;
        return this.list[index].details;
    }
    clearList(){
        this.list = [];
        barcodestore.clearList();
        barcodestore.add();
    }

    async exportValidatedBarcodes() {
        if (!this.list) return;
        //map model to export obj

        const client = ApiProvider.getApiClient();
        const result = await client.downloadScannedBarcodes(<DownloadBarcodeListRequestArguments>{
            list: this.list
        });


        await this.export(this.selectedState, result.json);
    }

    async validateScannedBarcodes() {

        this.triggerValidateOnTable = false;
        this.waiting = true;
        this.errorValidate = false;
        this._isValidated = false;


        this.triggerValidateOnTable = true;
        try {


            const result = await this.validate(this.selectedState);
            this._isValidated = result.isValid;
            this.errorValidate = !result.isValid;
         

        } catch (error) {
            this.errorValidate = true;
            console.log(error);
            console.log(this.list);

        }

        this.waiting = false;
    }



    async validate(state: string): Promise<ChangePorterByBarcodeCommandResponse> {

        if (!this.barcodes) return;

        const distinctBarcodeNo = (value: ScannedBarcode, index: number, collection: ScannedBarcode[]) => {
            return collection.map(x => x.number).indexOf(value.number) === index;
        }
        //remove duplicates
        let distinctBarcodes = this.barcodes.filter(distinctBarcodeNo)



        const client = ApiProvider.getApiClient();
 
        
        const result = await client.changePorterByBarcode(<ChangePorterByBarcodeCommandArguments><unknown>{
            state: state as ChangePorterByBarcodeCommandArgumentsState,
            Barcode: this.barcodes[0],
            ToPorter: this.selectedPorter.id,
        });


        this.errorValidate = !result.isValid;


        barcodestore.updateList(result.list.map(x => x.item));

        this.list = result.list;
        console.log("list now contains:", this.list);
        //map validated barcodes to store !
        //add validation list to component

        return result;
    }

}
Vue.component('barcode-change-porter', BarcodeChangePorterComponent);